class CartBillingInfo extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', debounce((event) => {
      if (!event.target.matches('input')) return;
      const body = JSON.stringify({
        attributes: {
          ico: this.querySelector('[name="attributes[ico]"]').value,
          dic: this.querySelector('[name="attributes[dic]"]').value,
          company_name: this.querySelector('[name="attributes[company_name]"]').value,
          partner_website: this.querySelector('[name="attributes[partner_website]"]').value,
        }
      });
      fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body });
    }, 300));
  }
}
customElements.define('cart-billing-info', CartBillingInfo);
